import type { PropsWithChildren, ReactNode } from 'react';
import { BookOpen } from 'lucide-react';
import { AuthPage } from '../features/auth/AuthPage';
import { useAuth } from './AuthContext';

interface AuthGateProps extends PropsWithChildren {
  authPage?: ReactNode;
}

const AccessStatus = ({ unavailable = false, message }: { unavailable?: boolean; message?: string }) => (
  <main className="auth-status" {...(unavailable ? { role: 'alert' } : { role: 'status' })}>
    <div className="auth-status__mark"><BookOpen aria-hidden="true" /></div>
    <strong>{unavailable ? 'Acesso temporariamente indisponível' : 'Abrindo seu espaço de leitura…'}</strong>
    {unavailable && <p>{message ?? 'Não foi possível iniciar o serviço de acesso. Tente novamente mais tarde.'}</p>}
    {!unavailable && <span className="auth-status__loader" aria-hidden="true" />}
  </main>
);

export const AuthGate = ({ children, authPage }: AuthGateProps) => {
  const auth = useAuth();

  if (!auth.isConfigured) return <AccessStatus unavailable message={auth.configurationMessage} />;
  if (auth.isLoading) return <AccessStatus />;
  if (!auth.isAuthenticated) return <>{authPage ?? <AuthPage />}</>;
  return <>{children}</>;
};
